/**
 * Offline sync helper: queues writes in IndexedDB and flushes when online.
 * The backend accepts /api/sync/batch with items[] to replay.
 */
const DB_NAME = "imsyaf_offline";
const STORE = "pending_ops";
const VERSION = 1;

function openDB() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "client_id" });
      }
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode) {
  const db = await openDB();
  return db.transaction(STORE, mode).objectStore(STORE);
}

export async function queueOp(op) {
  const store = await tx("readwrite");
  const client_id =
    op.client_id || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const record = { ...op, client_id, queued_at: new Date().toISOString() };
  await new Promise((res, rej) => {
    const r = store.add(record);
    r.onsuccess = res;
    r.onerror = () => rej(r.error);
  });
  return record;
}

export async function listPending() {
  const store = await tx("readonly");
  return new Promise((res, rej) => {
    const r = store.getAll();
    r.onsuccess = () => res(r.result || []);
    r.onerror = () => rej(r.error);
  });
}

export async function clearPending(clientIds) {
  const store = await tx("readwrite");
  for (const id of clientIds) store.delete(id);
}

export async function flushQueue(api) {
  if (!navigator.onLine) return { skipped: true };
  const items = await listPending();
  if (items.length === 0) return { count: 0 };
  try {
    const res = await api.post("/sync/batch", { items });
    const ok = (res.data?.results || []).filter((r) => r.ok).map((r) => r.client_id);
    await clearPending(ok);
    return { count: ok.length, results: res.data?.results || [] };
  } catch (e) {
    return { error: e.message };
  }
}
